import React from 'react'
import moment from 'moment'
import { useGlobalData } from '../../context/GlobalDataContext';

const Footer = ({ inFlow = false }) => {
  const { globalData } = useGlobalData();
  return (
    <footer
      className="footer"
      style={inFlow ? { bottom: 'auto', height: 'auto', left: 'auto', minHeight: 60, position: 'static', right: 'auto' } : undefined}
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-8">
            Copyright © {`${moment().year()}-${(moment().year() + 1).toString().slice(-2)}`} - {globalData?.TITLE_PREFIX} - New-building Ship Site
            Management. All Rights Reserved.
          </div>
          <div className="col-sm-4">
            <div className="text-sm-end d-none d-sm-block">
              Crafted with <i className="bx bx-heart" style={{ color: "red" }} /> by{" "}
              <a
                href='javascript:void(0);'
                title="New-building Ship Site Management V 1.0"
                style={{ color: "#006ccf" }}
              >
                {globalData?.COMPANY_NAME}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>

  )
}

export default Footer
